import { ApiClient } from "../../entities/NSwagGenerated"
import { useErrorToaster } from "./toaster"

export function useHistoryHelper() {
	const apiClient = new ApiClient(import.meta.env.VITE_API_URL?.toString())

	const updateAssessmentUpdatedByDate = async (assessmentId: string | undefined) => {
		if (assessmentId === undefined) return
		try {
			const res = await apiClient.updateAssessmentUpdatedByDate(assessmentId)
		} catch (err) {
			useErrorToaster(err)
		}
	}

	return { updateAssessmentUpdatedByDate }
}
